import { FaqCategoriesEffects } from './faq-categories.effect';

export const effects = [FaqCategoriesEffects];
export * from './faq-categories.effect';
